import useOrgGroupCombobox from './UseOrgGroupCombobox';

import Combobox from '../Combobox';

import Constants from '../../../utils/Constants';

import global from '../../GlobalStyle.module.css';

const OrgGroupCombobox = ({ label, name, valueToMatch, error, message, onChange, orgUnitId }) => {
  const { orgGroupsByOrgUnitState } = useOrgGroupCombobox(
    orgUnitId !== Constants.DEFAULT_ID && orgUnitId !== '' && orgUnitId !== undefined ? orgUnitId : '');

  return orgGroupsByOrgUnitState.message
    ? <span className={global.LoadingMsg}>{orgGroupsByOrgUnitState.message}</span>
    : (
      <Combobox
        label={label}
        name={name}
        isLoading={orgGroupsByOrgUnitState.isArrayLoading}
        items={orgGroupsByOrgUnitState.items}
        valueToMatch={valueToMatch}
        error={error}
        message={message}
        onChange={onChange} />
    );
};

export default OrgGroupCombobox;
